export const REDIRECT_URL_PARAM_NAME = 'redirectTo';

export const SIGNUP_PAGE_URL = '/sign-up'